import React from 'react'

export const notesColumns = (layout, role, handleEdit) => [
	{
		name: 'ID',
		selector: (row) => row.id,
		sortable: true,
		width: '10%'
	},
	{
		name: 'Regarding',
		selector: (row) => row.title || 'N/A',
		sortable: true,
		width: '30%'
	},
	{
		name: 'Student',
		selector: (row) => (row.name && row.surname ? `${row.name} ${row.surname}` : 'N/A'),
		sortable: true,
		width: '30%'
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '30%',
		cell: (row) => (
			<div className="d-flex gap-2">
				<button onClick={() => handleEdit(row)} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</button>
				{row.onDelete && (
					<button className="btn btn-danger btn-sm" onClick={row.onDelete}>
						 <i className="fa fa-trash"></i>
					</button>
				)}
			</div>
		)
	}
]
